import script from "/app/pages/Settings/registered_products.vue?type=script";
import { render } from "/app/pages/Settings/registered_products.vue?type=template";
script.render = render;
export default script;
